import React from "react";
import { Phone } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const PHONE_DISPLAY = "(407) 416-9541";
export const PHONE_HREF = "tel:+14074169541";

const CallBanner = () => {
  const { t } = useLanguage();

  return (
    <a
      href={PHONE_HREF}
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 h-14 flex items-center justify-center gap-3 bg-slate-900 text-white font-semibold tracking-wide uppercase shadow-[0_-2px_10px_rgba(0,0,0,0.25)] active:bg-slate-800"
    >
      <Phone size={20} fill="currentColor" />
      <span>
        {t.nav.callNow} {PHONE_DISPLAY}
      </span>
    </a>
  );
};

export default CallBanner;
